import Vue from 'vue'
import VueRouter from 'vue-router'
import { getToken } from '@/utils/auth'
import { getAltchaCopy, getAltchaToken, requiresAltchaVerification } from '@/utils/altchaGate'
import store from '../store'
import TokenWebView from '@consenlabs-fe/webview'

import i18n from '@/i18n'

import homePage from '@/views/home/index'
import indexPage from '@/views/index/index'
import marketPage from '@/views/market/market'
import tradePage from '@/views/trade/trade'
import assestPage from '@/views/assest/assest'
import minePage from '@/views/mine/mine'

import imitatePage from '@/views/trade/imitate'

import followPage from '@/views/follow/index'
import followDetailPage from '@/views/follow/detail'
import tradeFollowPage from '@/views/follow/tradeFollow'
import tradeApplyPage from '@/views/follow/tradeApply'

import loginPage from '@/views/login/login'
import registerPage from '@/views/login/register'
import resetPasswordPage from '@/views/login/resetPassword'

import financePage from '@/views/finance/finance'
import financeDetailPage from '@/views/finance/financeDetail'
import financeBuyPage from '@/views/finance/financeBuy'
import financeRolePage from '@/views/finance/role'
import myPositionPage from '@/views/finance/myPosition'
import noticePage from '@/views/index/notice'
import noticeDetailPage from '@/views/index/noticeDetail'
import rewardPage from '@/views/index/reward'

import rechargePage from '@/views/assest/recharge'
import withdrawPage from '@/views/assest/withdraw'
import transferPage from '@/views/assest/transfer'
import exchangePage from '@/views/assest/exchange'
import accountPage from '@/views/assest/account'
import assestLogPage from '@/views/assest/assestLog'
import bitPage from '@/views/assest/bit'

import sharePage from '@/views/mine/share'
import shareRolePage from '@/views/mine/shareRole'
import mySharePage from '@/views/mine/myShare'
import tradeSettingPage from '@/views/mine/tradeSetting'
import orderListPage from '@/views/mine/orderList'
import orderDetailPage from '@/views/mine/orderDetail'
import addressPage from '@/views/mine/address'
import addAddressPage from '@/views/mine/addAddress'
import editPasswordPage from '@/views/mine/editPassword'
import editSafePasswordPage from '@/views/mine/editSafePassword'
import userAuthPage from '@/views/mine/userAuth'
import langPage from '@/views/mine/lang'
import helpPage from '@/views/mine/help'
import feedbackPage from '@/views/mine/feedback'
import aboutPage from '@/views/mine/about'
import kefuPage from '@/views/mine/kefu'
import kefuFullscreenPage from '@/views/mine/kefuFullscreen'
import privacyPage from '@/views/mine/privacy'
import agreementPage from '@/views/mine/agreement'
import downloadPage from '@/views/mine/download'
import blockedPage from '@/views/blocked/blocked'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/verify'
  },
  {
    path: '/verify',
    name: 'altchaVerify',
    meta: { index: 0 },
    component: () => import('@/views/verify/index.vue')
  },
  {
    path: '/login',
    name: 'login',
    meta: {
      index: 3
    },
    component: loginPage
  },
  {
    path: '/register',
    name: 'register',
    meta: {
      index: 4
    },
    component: registerPage
  },
  {
    path: '/resetPassword',
    name: 'resetPassword',
    meta: {
      index: 4
    },
    component: resetPasswordPage
  },
  {
    path: '/home',
    name: 'home',
    component: homePage,
    children: [
      {
        path: '/index',
        name: 'index',
        meta: {
          index: 1
        },
        component: indexPage,
      },
      {
        path: '/market',
        name: 'market',
        meta: {
          index: 1
        },
        component: marketPage,
      },
      {
        path: '/trade',
        name: 'trade',
        meta: {
          index: 1
        },
        component: tradePage,
      },
   
      {
        path: '/assest',
        name: 'assest',
        meta: {
          index: 1
        },
        component: assestPage,
      },
      {
        path: '/mine',
        name: 'mine',
        meta: {
          index: 1
        },
        component: minePage,
      },
      
    ],
  },
  
  {
    path: '/finance',
    name: 'finance',
    meta: {
      index: 2
    },
    component: financePage,
  },
  {
    path: '/myPosition',
    name: 'myPosition',
    meta: {
      index: 3
    },
    component: myPositionPage,
  },
  {
    path: '/financeDetail',
    name: 'financeDetail',
    meta: {
      index: 4
    },
    component: financeDetailPage,
  },
  {
    path: '/financeBuy',
    name: 'financeBuy',
    meta: {
      index: 3
    },
    component: financeBuyPage,
  },
  {
    path: '/financeRole',
    name: 'financeRole',
    meta: {
      index: 4
    },
    component: financeRolePage,
  },
  {
    path: '/notice',
    name: 'notice',
    meta: {
      index: 2
    },
    component: noticePage,
  },
  {
    path: '/noticeDetail',
    name: 'noticeDetail',
    meta: {
      index: 3
    },
    component: noticeDetailPage,
  },
  {
    path: '/reward',
    name: 'reward',
    meta: {
      index: 2
    },
    component: rewardPage,
  },
  {
    path: '/rewardDetail',
    name: 'rewardDetail',
    meta: {
      index: 3
    },
    component: () => import('@/views/index/rewardDetail.vue'),
  },
  {
    path: '/share',
    name: 'share',
    meta: {
      index: 3
    },
    component: sharePage,
  },
  {
    path: '/shareRole',
    name: 'shareRole',
    meta: {
      index: 4
    },
    component: shareRolePage,
  },
  {
    path: '/myShare',
    name: 'myShare',
    meta: {
      index: 4
    },
    component: mySharePage,
  },
  {
    path: '/recharge',
    name: 'recharge',
    meta: {
      index: 3
    },
    component: rechargePage,
  },
  {
    path: '/withdraw',
    name: 'withdraw',
    meta: {
      index: 3
    },
    component: withdrawPage,
  },
  {
    path: '/address',
    name: 'address',
    meta: {
      index: 3
    },
    component: addressPage,
  },
  {
    path: '/addAddress',
    name: 'addAddress',
    meta: {
      index: 4
    },
    component: addAddressPage,
  },
  {
    path: '/transfer',
    name: 'transfer',
    meta: {
      index: 3
    },
    component: transferPage,
  },
  {
    path: '/exchange',
    name: 'exchange',
    meta: {
      index: 3
    },
    component: exchangePage,
  },
  {
    path: '/account',
    name: 'account',
    meta: {
      index: 2
    },
    component: accountPage,
  },
  {
    path: '/assestLog',
    name: 'assestLog',
    meta: {
      index: 4
    },
    component: assestLogPage,
  },
  {
    path: '/kefu',
    name: 'kefu',
    meta: {
      index: 4
    },
    component: kefuPage,
  },
  {
    path: '/kefuFullscreen',
    name: 'kefuFullscreen',
    meta: {
      index: 5
    },
    component: kefuFullscreenPage,
  },
  {
    path: '/userAuth',
    name: 'userAuth',
    meta: {
      index: 3
    },
    component: userAuthPage,
  },
  {
    path: '/editPassword',
    name: 'editPassword',
    meta: {
      index: 3
    },
    component: editPasswordPage,
  },
  {
    path: '/editSafePassword',
    name: 'editSafePassword',
    meta: {
      index: 3
    },
    component: editSafePasswordPage,
  },
  {
    path: '/tradeSetting',
    name: 'tradeSetting',
    meta: {
      index: 3
    },
    component: tradeSettingPage,
  },
  {
    path: '/bit',
    name: 'bit',
    meta: {
      index: 3
    },
    component: bitPage,
  },
  {
    path: '/lang',
    name: 'lang',
    meta: {
      index: 3
    },
    component: langPage,
  },
  {
    path: '/help',
    name: 'help',
    meta: {
      index: 3
    },
    component: helpPage,
  },
  {
    path: '/about',
    name: 'about',
    meta: {
      index: 3
    },
    component: aboutPage,
  },
  {
    path: '/privacy',
    name: 'privacy',
    meta: {
      index: 5
    },
    component: privacyPage,
  },
  {
    path: '/agreement',
    name: 'agreement',
    meta: {
      index: 5
    },
    component: agreementPage,
  },
  {
    path: '/feedback',
    name: 'feedback',
    meta: {
      index: 3
    },
    component: feedbackPage,
  },
  {
    path: '/imitate',
    name: 'imitate',
    meta: {
      index: 2
    },
    component: imitatePage,
  },
  {
    path: '/follow',
    name: 'follow',
    meta: {
      index: 2
    },
    component: followPage,
  },
  {
    path: '/followDetail',
    name: 'followDetail',
    meta: {
      index: 3
    },
    component: followDetailPage,
  },
  {
    path: '/tradeFollow',
    name: 'tradeFollow',
    meta: {
      index: 4
    },
    component: tradeFollowPage,
  },
  {
    path: '/tradeApply',
    name: 'tradeApply',
    meta: {
      index: 5
    },
    component: tradeApplyPage,
  },
  {
    path: '/orderList',
    name: 'orderList',
    meta: {
      index: 4
    },
    component: orderListPage,
  },
  {
    path: '/orderDetail',
    name: 'orderDetail',
    meta: {
      index: 5
    },
    component: orderDetailPage,
  },
  {
    path: '/download',
    name: 'download',
    meta: {
      index: 5
    },
    component: downloadPage,
  },
  {
    path: '/blocked',
    name: 'blocked',
    meta: {
      index: 5
    },
    component: blockedPage,
  },
  {
    path: '*',
    redirect: '/index'
  }
]

const router = new VueRouter({
  routes
})

const whiteArr = ['register', 'login', 'lang', 'index', 'market', 'trade', 'setting', 'commonSetting', 'notice', 'help', 'feedback', 'about', 'line', 'network', 'download', 'defi', 'rewardDetail']
const grayPage = ['assest', 'myPosition', 'financeDetail', 'myShare', 'account', 'address', 'follow', 'followDetail',]
router.beforeEach((to, from, next) => {
  if (grayPage.indexOf(to.name) > -1) {
    document.body.style.background  = '#F6F7F8'
  } else {
    document.body.style.background  = '#FFFFFF'
  }

  if (requiresAltchaVerification(to.name, getAltchaToken())) {
    return next({ name: 'altchaVerify', replace: true })
  }

  let token = getToken()
  if (token) {
    next()
  } else {
    if (whiteArr.indexOf(to.name) > -1) {
      next()
    } else {
      // next('login')
      next()
    }
  }
})

router.afterEach((to) => {
  window.scrollTo({top: 0})
  // 修改顶部title
  let key = to.name
  if (key == 'trade' || key == 'account' || key == 'assestLog' ) {
    let query = to.query
    let type = query.type
    key += type
  }
  let title = key === 'altchaVerify' ? getAltchaCopy().title : i18n.t(`pageTitle.${key}`)
  document.title = title
  try {
    if (TokenWebView && TokenWebView.isTokenEnv()) {
      TokenWebView.apis.navigator.setTitle(title)/*  */
    }
  } catch {
    
  }

})

export default router
